import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, FieldArray } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';
import renderTasks from './ClinicalIncidentTask';

class ClinicalIncidentForm extends React.Component {
  constructor() {
    super();

    this.state = {
      parentId: 0,
      showPatientHealthTypes: false,
      showVisitorHealthTypes: false,
      showEmployeeHealthTypes: false,
      showPatients: false,
      showVisitors: false,
      showEmployees: false,
      showNotification: false,
    };
  }

  componentDidMount() {
    const {
      initialValues: { individualImpactedType, isCOMNotified, status },
    } = this.props;
    if (individualImpactedType !== null) {
      this.setState({ showPatients: (individualImpactedType.name === 'Patient') });
      this.setState({ showVisitors: (individualImpactedType.name === 'Visitor') });
      this.setState({ showEmployees: (individualImpactedType.name === 'Proactive MD Employee') });
    }
    if (status === null) {
      const option = { id: 1, name: 'New' };
      this.props.change('status', option);
    }
    var radioYes = document.getElementById("rdoYes");
    var radioNo = document.getElementById("rdoNo");
    if (isCOMNotified) {
      radioYes.checked = true;
      this.setState({ showNotification: true });
    }
    else {
      radioNo.checked = true;
      this.setState({ showNotification: false });
    }
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderPatientHealthTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          key={this.state.parentId}
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchPatientHealthTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPatientHealthTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchPatientHealthTypes = () => {
    this.props.searchPatientHealthTypes(this.state.parentId);
  }

  onPatientHealthTypeChange = (val) => {
    this.props.change('patientHealthType', val);
  }

  renderVisitorHealthTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchVisitorHealthTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onVisitorHealthTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onVisitorHealthTypeChange = (val) => {
    this.props.change('visitorHealthType', val);
  }

  renderEmployeeHealthTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchEmployeeHealthTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onEmployeeHealthTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onEmployeeHealthTypeChange = (val) => {
    this.props.change('employeeHealthType', val);
  }

  renderTimeZoneSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchTimeZones}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Timezone..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onTimeZoneChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onTimeZoneChange = (val) => {
    this.props.change('timeZone', val);
  }

  renderTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onTypeChange = (val) => {
    this.props.change('individualImpactedType', val);
    this.props.change('patient', null);
    if (val.name === 'Patient') {
      this.setState({ showPatients: true });
      this.setState({ showPatientHealthTypes: true });
      this.setState({ showVisitorHealthTypes: false });
      this.setState({ showEmployeeHealthTypes: false });
    }
    else 
      this.setState({ showPatients: false });

    if (val.name === 'Visitor') {
      this.setState({ showVisitorHealthTypes: true });
      this.setState({ showEmployeeHealthTypes: false });
      this.setState({ showPatientHealthTypes: false });
      this.setState({ showPatients: false });
      this.props.change('firstName', null);
      this.props.change('lastName', null);
      this.props.change('DOB', null);
      this.props.change('gender', null);
    }
    else
      this.setState({ showVisitorHealthTypes: false });

    if (val.name === 'Proactive MD Employee') {
      this.setState({ showEmployeeHealthTypes: true });
      this.setState({ showVisitorHealthTypes: false });
      this.setState({ showPatientHealthTypes: false });
      this.setState({ showPatients: false });
      this.props.change('firstName', null);
      this.props.change('lastName', null);
      this.props.change('DOB', null);
      this.props.change('gender', null);
    }
    else
      this.setState({ showEmployeeHealthTypes: false });
   
  }

  renderStatusSelect = ({
    meta: { touched, error, warning },
    label,
    disabled,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          isDisabled={disabled}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchStatuses}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Status..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onStatusChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onStatusChange = (val) => {
    this.props.change('status', val);
  }

  renderGenderSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchGenders}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Gender..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onGenderChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onGenderChange = (val) => {
    this.props.change('gender', val);
  }

  renderSelect1 = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" value={this.state.selectedOption}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect2 = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTextarea = ({
    input,
    label,
    type,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label"></label>
      <div className="col-md-10">
        <label>{label}</label>
        <textarea
          {...input}
          rows="5"
          //placeholder={label}
          type={type}
          className={`form-control`}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
  
  renderCOMNotified = ({
    input,
    label,
    type,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <div className="btn-group">
            <label className="btn btn-default">
              <input id="rdoYes" type="radio" name="isCOMNotified" value="true" onChange={this.handleChange} />
              Yes </label>
            <label className="btn btn-default">
              <input id="rdoNo" type="radio" name="isCOMNotified" value="false" onChange={this.handleChange} />
              No </label>
        </div>
      </div>
    </div>
  );

  handleChange = e => {
    const { value } = e.target;
    this.props.change('isCOMNotified', value);
    if (value === "true") {
      this.setState({ showNotification: true });
    }
    else {
      this.setState({ showNotification: false });
      this.props.change('notificationAt', null);
      this.props.change('notificationAtTime', null);
    }
  };

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderUsersSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onUserChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onUserChange = (val) => {
    this.props.change('coManager', val);
    this.props.change('COManagerId', val.id);
  }

  searchUsers = (search) => {
    return this.props.searchUsers(search, 'isActive');
  }

  searchTaskUsers = (search) => {
    return this.props.searchTaskUsers(search, 'isActive');
  }

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('client', val);
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderLocationsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchLocations}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Location Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onLocationChange = (val) => {
    this.props.change('location', val);
  }

  searchLocations = (search) => {
    return this.props.searchLocations(search, 'isActive');
  }

  renderPatientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchPatients}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type Patient Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPatientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPatientChange = (val) => {
    this.props.change('patient', val);

    const d = val.name.split(' ');
    this.props.change('firstName', d[0]);
    this.props.change('lastName', d[1]);
    //this.props.change('DOB', d[2].substring(1, d[2].length));
    this.props.change('DOB', moment(new Date(d[2].substring(1, d[2].length))).format('YYYY-MM-DD'));

    if (d[3].substring(0, 1) === 'M') {
      const option = { id: 1, name: 'Male' };
      this.props.change('gender', option);
    }
    else if (d[3].substring(0, 1) === 'F') {
      const option = { id: 2, name: 'Female' };
      this.props.change('gender', option);
    }
    else {
      const option = { id: 3, name: 'Other' };
      this.props.change('gender', option);
    }
  }

  searchPatients = (search) => {
    return this.props.searchPatients(search, 'isActive');
  }

  onChange = (e, val) => {
    this.props.change('patientHealthTypeId', null);
    this.setState({ parentId: val });
    this.props.searchPatientHealthTypes(val);
    this.setState({ showPatientHealthTypes: true });
  }

  onChildChange = (e, val) => {
    this.props.change('patientHealthTypeId', val);
  }

  renderAssignmentSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name..."
          menuPlacement="top"
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9',
            }),
          }}
          onChange={this.onAssignmentChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onAssignmentChange = (val) => {
    this.props.change('taskAssignedTo', val);
  }

  renderToggler = props => (
    <div className={`form-group`}>
      <label className="col-md-2 text-right">{props.label}</label>
      <div className="col-md-10">
        <input type="checkbox" {...props.input} />
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  render() {
    const {
      types,
      childTypes,
      handleSubmit,
      initialValues,
      pristine,
      submitting,
      mode,
    } = this.props;

    if (initialValues.patientHealthTypeParentId)
      this.props.searchPatientHealthTypes(initialValues.patientHealthTypeParentId);
    else if (!this.state.showPatientHealthTypes)
      this.props.searchPatientHealthTypes(1);

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Clinical Occurrence Report</legend>
          <Field
            name="status"
            component={this.renderStatusSelect}
            label="Status"
            disabled={mode === 'Add' ? true : false}
          />
          <Field
            name="location"
            component={this.renderLocationsSelect}
            label="Health Center"
          />
          <Field
            name="client"
            component={this.renderClientsSelect}
            label="Client"
          />
          <Field
            className="form-control"
            name="occurrenceAtDate"
            component={this.renderDateField}
            type="text"
            placeholder="Date of Occurrence"
            label="Date of Occurrence"
          />
          <Field
            name="occurrenceAtTime"
            component={this.renderField}
            type="text"
            label="Time of Occurrence"
            help="HH:MM:SS (24 hour format)"
          />
          <Field
            name="timeZone"
            component={this.renderTimeZoneSelect}
            label="TimeZone"
          />
          <Field
            name="individualImpactedType"
            component={this.renderTypesSelect}
            label="Type of Individual Impacted"
          />
          {this.state.showPatients &&
            <Field
              name="patient"
              component={this.renderPatientsSelect}
              label="Patient"
            />
          }
          <Field
            name="firstName"
            component={this.renderField}
            type="text"
            placeholder="First Name"
            label="First Name"
          />
          <Field
            name="lastName"
            component={this.renderField}
            type="text"
            placeholder="Last Name"
            label="Last Name"
          />
          <Field
            className="form-control"
            name="DOB"
            component={this.renderDateField}
            type="text"
            label="Date of Birth"
          />
          <Field
            name="gender"
            component={this.renderGenderSelect}
            label="Gender"
          />
          <Field
            name="parent"
            component={this.renderField}
            type="text"
            placeholder="Parent"
            label="Parent/Guardian (if minor)"
          />
          {(this.state.showVisitors || this.state.showVisitorHealthTypes) &&
            <Field
              name="visitorHealthType"
              component={this.renderVisitorHealthTypesSelect}
              label="Visitor Health"
            />
          }
          {(this.state.showEmployees || this.state.showEmployeeHealthTypes) &&
            <Field
            name="employeeHealthType"
            component={this.renderEmployeeHealthTypesSelect}
              label="Proactive MD Employee Health"
            />
          }
          {(this.state.showPatients) &&
            <Field
              className="form-control"
              component={this.renderSelect}
              name="patientHealthTypeParentId"
              type="text"
              label="Patient Health"
              onChange={this.onChange}
            >
              {types &&
                types.map(el => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
            </Field>
          }
          {/*{(showPatients || this.state.showPatients || this.state.showPatientHealthTypes) &&*/}
          {/*  <Field*/}
          {/*    key={this.state.parentId}*/}
          {/*    name="patientHealthType"*/}
          {/*    component={this.renderPatientHealthTypesSelect}*/}
          {/*    label="Select"*/}
          {/*  />*/}
          {/*}*/}
          {(this.state.showPatients || this.state.showPatientHealthTypes) &&
            <Field
            className="form-control"
            name="patientHealthTypeId"
            component={this.renderSelect}
            type="text"
            label="Select"
            onChange={this.onChildChange}
          >
            {childTypes &&
              childTypes.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
          }
          <Field
            className="form-control"
            name="description"
            component={this.renderTextarea}
            type="text"
            placeholder="Description"
            label="1.Occurrence Description (brief, factual, include patient assessment if applicable):"
          />
          <Field
            className="form-control"
            name="response"
            component={this.renderTextarea}
            type="text"
            placeholder="Response"
            label="2.Response to Occurrence (immediate actions, treatment required if applicable):"
          />
          <Field
            className="form-control"
            name="outcomes"
            component={this.renderTextarea}
            type="text"
            placeholder="Outcomes"
            label="3.Outcomes (patient disposition, response to treatment if applicable):"
          />
            <Field
              name="isCOMNotified"
              component={this.renderCOMNotified}
              label="Was COM Notified?"
            />
          <Field
            name="coManager"
            component={this.renderUsersSelect}
            label="Clinical Operations Manager"
          />
          {this.state.showNotification &&
            <Field
              className="form-control"
              name="notificationAt"
              component={this.renderDateField}
              type="text"
              label="Date of Notification"
            />
          }
          {this.state.showNotification &&
            <Field
              name="notificationAtTime"
              component={this.renderField}
              type="text"
              label="Time of Notification"
              help="HH:MM:SS (24 hour format)"
            />
          }
        </fieldset>
        <legend>Tasks</legend>
        <fieldset>
           <FieldArray
            name="tasks"
            component={renderTasks}
            props={{ searchUsers: this.searchTaskUsers }}
          />
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting || this.props.isExecutive}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div >
      </form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.occurrenceAtDate) {
    errors.occurrenceAtDate = 'Required';
  }

  if (!values.occurrenceAtTime) {
    errors.occurrenceAtTime = 'Required';
  }
  else
  {
    var validateOccurrenceTime = moment(values.occurrenceAtTime, 'HH:mm:ss', true).isValid();
    if (!validateOccurrenceTime)
      errors.occurrenceAtTime = 'Please enter valid time format';
  }

  if (values.notificationAtTime) {
    var validateNotificationTime = moment(values.notificationAtTime, 'HH:mm:ss', true).isValid();
    if (!validateNotificationTime)
      errors.notificationAtTime = 'Please enter valid time format';
  }

  if (!values.description) {
    errors.description = 'Required';
  }

  if (!values.response) {
    errors.response = 'Required';
  }

  if (!values.outcomes) {
    errors.outcomes = 'Required';
  }

  if (!values.individualImpactedType) {
    errors.individualImpactedType = 'Required';
  }
  else {
    if (values.individualImpactedType.name === 'Patient' && !values.patient) {
      errors.patient = 'Required';
    }
    if (values.individualImpactedType.name === 'Visitor') {
      if (!values.firstName) {
        errors.firstName = 'Required';
      }
      if (!values.lastName) {
        errors.lastName = 'Required';
      }
      if (!values.DOB) {
        errors.DOB = 'Required';
      }
      if (!values.gender) {
        errors.gender = 'Required';
      }
    }
    if (values.individualImpactedType.name === 'Proactive MD Employee') {
      if (!values.firstName) {
        errors.firstName = 'Required';
      }
      if (!values.lastName) {
        errors.lastName = 'Required';
      }
      if (!values.DOB) {
        errors.DOB = 'Required';
      }
      if (!values.gender) {
        errors.gender = 'Required';
      }
    }
  }

  if (values.task) {
    errors.dueDate = 'Required';
    errors.taskAssignedTo = 'Required';
  }

  if (!values.location) {
    errors.location = 'Required';
  }

  if (!values.coManager) {
    errors.coManager = 'Required';
  }

  if (!values.status) {
    errors.status = 'Required';
  }
  return errors;
};

ClinicalIncidentForm = connect(state => ({
  formValues: getFormValues('report')(state),
  initialValues: state.cirmanager.report,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'report' })(ClinicalIncidentForm));
export default ClinicalIncidentForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ClinicalIncidentForm.js